/**
 * 是否需要隐藏奖品的数字
 */
function needHideRewardNum(prodId) {
    return prodId == GamePropsType.kUnlimitedenergy_10 || prodId == GamePropsType.kEnergyInf || prodId == GamePropIds.kEnergyInf_1Hour || prodId == GamePropIds.kEnergyInf_10Min
}
exports.needHideRewardNum = needHideRewardNum